import http from 'axios'

export default {
  getAdminComparateurMargeUnites: () => {
    return http.get(`/web/v1/comparateur-marge/unite`)
  },
  getAdminComparateurMargeUniteEngrais: () => {
    return http.get(`/web/v1/comparateur-marge/unite-engrais`)
  },
  createAdminComparateurMargeUniteEngrais: (uniteEngrais) => {
    return http.post(`/web/v1/comparateur-marge/unite-engrais`, uniteEngrais)
  },
  updateAdminComparateurMargeUniteEngrais: (uniteEngrais) => {
    return http.put(`/web/v1/comparateur-marge/unite-engrais/${uniteEngrais.id}`, uniteEngrais)
  },
  deleteAdminComparateurMargeUniteEngrais: (id) => {
    return http.delete(`/web/v1/comparateur-marge/unite-engrais/${id}`)
  },
  getComparateurMargeCulturesPresentes: (isAdmin) => {
    return http.get(`/web/v1/comparateur-marge/parametre/culture?isAdmin=${isAdmin}`)
  },
  getAdminComparateurMargeByGraine: (id) => {
    return http.get(`/web/v1/comparateur-marge/${id}`)
  },
  createAdminComparateurParametreMarge: (parametre) => {
    return http.post(`/web/v1/comparateur-marge/parametre`, parametre)
  },
  updateAdminComparateurParametreMarge: (parametre) => {
    return http.put(`/web/v1/comparateur-marge/parametre/${parametre.id}`, parametre)
  },
  deleteAdminComparateurParametreMarge: (id) => {
    return http.delete(`/web/v1/comparateur-marge/parametre/${id}`)
  },
  updateAdminComparateurIndicateurNonChiffreMarge: (indicateurNonChiffre) => {
    return http.put(`/web/v1/comparateur-marge/indicateur-non-chiffre/${indicateurNonChiffre.id}`, indicateurNonChiffre)
  },
  getAdherentComparateurMarge: (numtiers, culturesSelected) => {
    let params = ''
    params += `codesCulture=${culturesSelected[0]},${culturesSelected[1]},${culturesSelected[2]}`
    return http.get(`/web/v1/adherent/${numtiers}/comparateur-marge?${params}`)
  },
  updateAdherentComparateurMarge: (adherentComparateurMarge) => {
    return http.put(`/web/v1/adherent/${adherentComparateurMarge.numtiers}/comparateur-marge/${adherentComparateurMarge.id}`, adherentComparateurMarge)
  },
  deleteAdherentComparateurMarge: (numtiers,) => {
    return http.delete(`/web/v1/adherent/${numtiers}/comparateur-marge`)
  },
}
